/* eslint-disable react-hooks/exhaustive-deps */
import { ApButtonSecondary } from '@alixpartners/ui-components';
import BreakDownFilters from 'SpendController/Components/BreakDownFilters/BreakDownFilters';
import {
	ColumnContainer,
	Container,
	GridContainer,
	GridItem,
	Header,
	HeaderSpan,
	RefreshSpan,
	TableFilterHeader,
} from 'SpendController/Components/Components.styles';
import LoadingSpinner from 'SpendController/Components/LoadingSpinner/LoadingSpinner';
import Summary from 'SpendController/Components/Summary/Summary';
import TableView from 'SpendController/Components/TableView';
import { TableWrapper } from 'SpendController/Components/TableView/TableView.style';
import { useSpendControllerFiltersContext } from 'SpendController/Contexts/SpendControllerFiltersProvider';
import {
	GL_HEADER,
	GL_REFRESH_HEADER,
	extractSelectedArrays,
	combinePreWorkshopBaselineKpiData,
	combinePreWorkshopData,
	MICROTAIL_BASELINE_KPI_DATA,
	MICROTAIL_PRELIMINARY_SAVINGS_KPI_DATA,
	MICROTAIL_VENDOR_KPI_DATA,
	combineMicroTailVendorData,
} from 'SpendController/utils';
import React, { useEffect, useState } from 'react';
import {
	getMicroTailBaselineSummaryKpis,
	getMicroTailPreliminarySavingsSummary,
	getMicroTailVendorActionKpis,
} from 'utils/apiRequests';

const healthBars = [
	'Micro Tail Baseline Spend Summary by Vendor Action',
	'Identified Vendor Actions',
	'Pre-Workshop Preliminary Savings Summary',
];

function MicroTailLaunch() {
	const [microTailBaselineKpiData, setMicroTailBaselineKpiData] = useState(
		MICROTAIL_BASELINE_KPI_DATA
	);
	const [microTailVendorKpiData, setMicroTailVendorKpiData] = useState(
		MICROTAIL_VENDOR_KPI_DATA
	);
	const [microPreliminaryKpiData, setMicroPreliminaryKpiData] = useState(
		MICROTAIL_PRELIMINARY_SAVINGS_KPI_DATA
	);
	const [reFresh, setrefresh] = useState(false);
	const [selectedKPI, setSelectedKPI] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [gridApi, setGridApi] = useState(null);

	const selectedSpendType = ['MICRO'];
	const {
		filters,
		microLaunchColumnDefs,
		filterModelData,
		refresh,
		setRefresh,
		uploadRefresh,
		handleSpendControllerFilters,
		setSpendType,
		setUploadRefresh,
	} = useSpendControllerFiltersContext();

	useEffect(
		() => {
			handleKpiData(filters, true);
		},
		[filters]
	);
	useEffect(
		() => {
			refresh && handleKpiData(filters);
		},
		[refresh]
	);
	useEffect(
		() => {
			uploadRefresh &&
				(() => {
					handleSpendControllerFilters();
					handleKpiData(filters);
				})();
		},
		[uploadRefresh]
	);
	useEffect(() => {
		setSpendType(selectedSpendType);
	}, []);
	const handleKpiData = async (filters, realTime = false) => {
		const tempFilters = extractSelectedArrays(filters);
		const microFilters = Object.assign({}, tempFilters);
		microFilters.tailSpendType = ['MICRO'];
		realTime && setIsLoading(true);
		const microTailBaselineKpiDataResponse = await getMicroTailBaselineSummaryKpis(
			microFilters
		);
		const microTailVendorActionResponse = await getMicroTailVendorActionKpis(
			microFilters
		);
		const microTailPreliminaryKpiResponse = await getMicroTailPreliminarySavingsSummary(
			microFilters
		);
		const tempMicroTailBaselineKpiData = combinePreWorkshopBaselineKpiData(
			microTailBaselineKpiDataResponse.data,
			microTailBaselineKpiData.data
		);
		setMicroTailBaselineKpiData({
			...microTailBaselineKpiData,
			data: tempMicroTailBaselineKpiData,
		});
		const newWorkShopKpiData = combinePreWorkshopData(
			microTailPreliminaryKpiResponse,
			microPreliminaryKpiData.data
		);
		setMicroPreliminaryKpiData({
			...microPreliminaryKpiData,
			data: newWorkShopKpiData,
		});

		const tempMicroTailVendorData = combineMicroTailVendorData(
			microTailVendorActionResponse,
			microTailVendorKpiData.data
		);
		setMicroTailVendorKpiData({
			...microTailVendorKpiData,
			data: tempMicroTailVendorData,
		});
		realTime && setIsLoading(false);
		setRefresh(false);
	};
	const handleClick = index => {
		setSelectedKPI(index);
	};
	return (
		<Container>
			<LoadingSpinner visible={isLoading} message={`Loading`} />

			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				<GridContainer>
					{healthBars.map((name, index) => (
						<GridItem
							key={index}
							selected={selectedKPI === index}
							onClick={() => handleClick(index)}
						>
							{name}
						</GridItem>
					))}
				</GridContainer>
				<ApButtonSecondary
					onClick={() => {
						setUploadRefresh(state => !state);
						setrefresh(state => !state);
					}}
					small
					style={{ margin: '1%' }}
				>
					Refresh/Save
				</ApButtonSecondary>
			</div>

			{selectedKPI === 0 && (
				<div style={{ padding: '0px 0 0 10px' }}>
					<Summary {...microTailBaselineKpiData} />
				</div>
			)}
			{selectedKPI === 1 && (
				<div style={{ padding: '0px 0 0 10px' }}>
					<Summary {...microTailVendorKpiData} />
				</div>
			)}
			{selectedKPI === 2 && (
				<div style={{ padding: '0px 0 0 10px' }}>
					<Summary {...microPreliminaryKpiData} />
				</div>
			)}

			<ColumnContainer>
				<Header>
					<RefreshSpan>{GL_REFRESH_HEADER}</RefreshSpan>
				</Header>
				<TableFilterHeader>
					<HeaderSpan>{GL_HEADER}</HeaderSpan>
					<BreakDownFilters gridApi={gridApi} />
				</TableFilterHeader>
				<TableWrapper n={7}>
					<TableView
						data={microLaunchColumnDefs}
						columnDefs={microLaunchColumnDefs.headers}
						filters={filterModelData}
						mainfilters={filters}
						handleCall={handleKpiData}
						selectedSpendType={selectedSpendType}
						micro
						refresh={reFresh}
						setGridApi={setGridApi}
						gridApi={gridApi}
					/>
				</TableWrapper>
			</ColumnContainer>
		</Container>
	);
}

export default MicroTailLaunch;
